import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { LogTime } from '../../../../actions/forFrontEnd_Log';
import comm_imgs from '../../../../comm_imgs';



const BedStateRow = (props) => {
  const { t } = useTranslation();
  const ONE_DAY = 86400000;
  const shift = props.shift;
  const state = props.state;
  const mobilityData = props?.mobilityData;
  const store_alerts = props.store_alerts;
  const prevDayAlerts = props.prevDayAlerts || [];   // ✅ 新增這行
  const d = new Date(props.date);
  const dateStr = String(props.date).slice(0, 10);
  const dateStamp = new Date(`${dateStr}T08:00:00+08:00`).getTime();
  const [alertRow, setAlertRow] = useState([]);
  const store_macAlertSettings = useSelector((state) => state.store_mac_alert_setting.orign_macAlerts_array)[0];
  const isLastActiveDay = props.isLastActiveDay || false;
  useEffect(() => {
    let MS = store_macAlertSettings.day_start_at;
    let NS = store_macAlertSettings.mid_start_at;
    let GS = store_macAlertSettings.night_start_at;
    let row = [];
    let len = store_alerts.length;
    const combinedAlerts = [...store_alerts, ...prevDayAlerts];
    if (combinedAlerts.length === 0 || dateStamp === null) {
      return;
    }
    const result = mergeMobilityAndAlerts(mobilityData, combinedAlerts, dateStamp, isLastActiveDay);
    const nowMs = Date.now();
    const isToday = nowMs >= dateStamp && nowMs < dateStamp + ONE_DAY;

    // 修改後
    if (isToday && result.length > 0) {
      const currentTimeMs = new Date().getTime();
      const lastSeg = result[result.length - 1];
      const segStartMs = dateStamp + (lastSeg.left / 100) * ONE_DAY;
      const segEndMs = segStartMs + lastSeg.secs * 1000;

      if (segEndMs > currentTimeMs) {
        // ✅ segment 延伸到未來（正常今天情況）→ 截斷到現在
        const truncatedSecs = Math.max(0, (currentTimeMs - segStartMs) / 1000);
        if (truncatedSecs > 0) {
          row = [...result.slice(0, -1), { ...lastSeg, secs: truncatedSecs }];
        } else {
          row = [...result.slice(0, -1)];
        }
      } else {
        // ✅ segment 已在過去結束（最後一筆是 HIDE 狀態造成提早截止）→ 直接使用
        row = [...result];
      }
    } else {
      row = [...result];
    }
    
    // ✅ 加這行，store_alerts 為空就不往下走
    if (!store_alerts[0]) {
      setAlertRow(row);
      return;
    }
    
    if (shift === 'MS' || shift === 'NS') {
      let alert1 = {
        bedState: 0,
        bedStateAlertLevel: 0,
        bed_id: store_alerts[0].bed_id,
        index: store_alerts.length + 1,
        resident_id: store_alerts[0].resident_id,
        secs: proccessShift(shift).tz1,
        startTag: 1,
        timestamp: new LogTime().getFullTime_withoutMillsec(),
      };
      let alert2 = {
        bedState: 0,
        bedStateAlertLevel: 0,
        bed_id: store_alerts[0].bed_id,
        index: store_alerts.length + 1,
        resident_id: store_alerts[0].resident_id,
        secs: proccessShift(shift).tz2,
        timestamp: new LogTime().getFullTime_withoutMillsec(),
      };
      row.push(alert1);
      row.push(alert2);
    } else if (shift === 'GS') {
      let alert = {
        bedState: 0,
        bedStateAlertLevel: 0,
        bed_id: store_alerts[0].bed_id,
        index: store_alerts.length + 1,
        resident_id: store_alerts[0].resident_id,
        secs: proccessShift(shift).tz1,
        startTag: 2,
        rightShift: MS,
        timestamp: new LogTime().getFullTime_withoutMillsec(),
      };
      row.push(alert);
    }

    if (nowMs >= dateStamp && nowMs < dateStamp + ONE_DAY) {
      let currentTime = new Date().getTime();
      let alert = {
        bedState: 0,
        bedStateAlertLevel: 0,
        bed_id: store_alerts[0].bed_id,
        index: store_alerts.length + 1,
        resident_id: store_alerts[0].resident_id,
        // secs: (ONE_DAY + dateStamp - new Date().getTime()) / 1000,
        secs: (dateStamp + ONE_DAY - currentTime) / 1000,
        timestamp: new LogTime().getFullTime_withoutMillsec(),
      };
      row.push(alert);
    }
    setAlertRow(row);
    function proccessShift(_s) {
      let tz1 = 0;
      let tz2 = 0;
      if (_s === 'MS') {
        tz1 = MS;
        tz2 = 86400 - NS;
      } else if (_s === 'NS') {
        tz1 = NS;
        tz2 = 86400 - GS;
      } else {
        tz1 = GS;
        tz2 = 0;
      }
      return {
        tz1: tz1,
        tz2: tz2,
      };
    }
    return () => {
      setAlertRow([]);
    };
  }, [store_alerts, prevDayAlerts, dateStamp, shift, store_macAlertSettings, props.date]);

  return (
    <div className="w-100 h-80 blue_bgC mar-5 t fx-d-c fx-cspar">
      <div className="w-100 fx-d-r br-10 h-30 fx-fsc">
        <div className="w-10 fx-ccc">
          <div className="h-60 fx-ccc w-100 ">{t('HISTORY_RECORD.DAILY_CHART')}</div>
        </div>
        <div className="bgC-border-bold w-100 font-s fx-reverse pos-r z-2 h-40">
          {alertRow.length !== 0
            ? alertRow.map((res, index) => {
              let _width = `${(res.secs / 86400) * 100}%`;
              return <StatePeriod state={state} rightShift={res.rightShift} startTag={res.startTag} key={index} width={_width} res={res} index={index} />;
            })
            : null}
        </div>
      </div>
      <HourInterval width={'w-100'} date={props.date} />
      <LegendRow />
    </div>
  );
};
export default BedStateRow;

// ------ 時間軸圖表標示 -------------------------
const HourInterval = (props) => {
  const { t } = useTranslation();
  const timeArray = createTimeArray();
  // ✅ 正確：直接切割字串，完全不碰時區
  const dateStr = String(props.date).slice(0, 10); // "2024-05-22"
  const [, currentMonth, currentDay] = dateStr.split('-').map(Number);
  let nextDay = currentDay + 1;
  let nextMonth = currentMonth;
  // 簡易進位（若有需要更嚴謹可用 UTC 方法）
  const daysInMonth = new Date(Date.UTC(Number(dateStr.slice(0,4)), currentMonth, 0)).getDate();
  if (nextDay > daysInMonth) { nextDay = 1; nextMonth += 1; }
  return (
    <>
      <div className="w-100 fx-d-r br-10 fx-fsc h-20">
        <div className="w-10 fx-ccc">
          <div className="h-60 fx-ccc w-100">{t('ADMIN.CONNECTION_HIS_PAGE.TIME_LINE')}</div>
        </div>
        <div className={`${props.width} fx-d-r font-s fx-cspbt h-3`}>
          {timeArray.map((time, index) => {
            return (
              <div
                className={`
                               ${time.minute % 20 === 0 ? 'right_border' : ''}
                               ${time.minute === 0 ? 'h-hours right_border_2' : 'h-minutes'}
                           `}
                key={index}>
                <div className="pos-a left-hour">{time.minute === 0 ? (time.hour < 10 ? `0${time.hour}` : time.hour) : null}</div>
              </div>
            );
          })}
        </div>
      </div>
      <div className="fx-d-r w-100" style={{ alignSelf: 'flex-start' }}>
        <div style={{ width: '68%', paddingLeft: '8%' }}>{`${currentMonth}/${currentDay}`}</div>
        <div>{`${nextMonth}/${nextDay}`}</div>
      </div>
    </>
  );
};
//  ------ 每個登入登出區段 -------------------------
const StatePeriod = (props) => {
  let res = props.res;
  const { t } = useTranslation();
  const [mouseX, setMouseX] = useState(0);
  const [hoverBtm, setHoverBtm] = useState(false);
  function toggleHover() {
    setHoverBtm(!hoverBtm);
  }
  let width = window.innerWidth;
  function getMousePosition(e) {
    toggleHover();
    let percent = Math.floor(e.clientX / width);
    setMouseX(percent);
  }
  let dh = dataHandler_alert(res.bedStateAlertLevel, res.bedState);
  let level = dh.level;
  let msg = dh.msg;
  let pic = dh.img;
  let _style = {
    width: props.width,
    left: `${res.left}%`,
    zIndex: `${res.index}`,
  };

  return (
    <div style={_style} onMouseEnter={getMousePosition} onMouseLeave={getMousePosition} className={`${transColor(res.bedState, res.bedStateAlertLevel, props.state)} h-100 pos-a fx-d-r `}>
      {hoverBtm && transColor(res.bedState, res.bedStateAlertLevel, props.state) !== 'bgC-blueBACK' ? (
        <div className="bgC-white pos-a hover_card_his" style={{ left: `${mouseX}%`, top: 10 }}>
          <div className={`w-100 h-15 topping ${transColor(res.bedState, res.bedStateAlertLevel, props.state)}`}></div>
          <div className="fx-d-r fx-cspar h-75">
            <div>
              <div>{t(res.timestamp)}</div>
              <div>
              {/* <div>
                {level === 'normal' ? t('GLOBAL.BED_STATE.LEVEL1') : level === 'warning' ? t('GLOBAL.BED_STATE.LEVEL2') : t('GLOBAL.BED_STATE.LEVEL3')}：{t(msg)}
              </div> */}
              </div>
                {t(msg)}
            </div>
          </div>
        </div>
      ) : null}
      {level === 'emergency' ? <div className="bedStateRowTag"></div> : null}
    </div>
  );
};
//  ------ 每個登入登出區段 -------------------------

// ------ 圖表標示 -------------------------
const LegendRow = (props) => {
  const { t } = useTranslation();

  const row1 = [
    [2, 217],
    [1, 206],
    [1, 203],
  ];
  const row3 = [
    [0, 4],
    [0, 12],
    [0, 1],
  ];

  return (
    <div className="w-100 h-70 fx-d-r fx-cspar mar-15 t">
      <div className="h-100 w-40 fx-d-c legend">
        <div className="w-40 h-20 fx-ccc mar-5 l">{t('GLOBAL.NOTIFICATION')}</div>
        <div className="gridLegend_row h-70 fx-d-c">
          {row1.map((res) => (
            <div className="h-80 w-100 fx-d-r fx-ccc" key={String(res[1]) + String(res[0])}>
              <div className={`w-15 h-30 bgC-border ${transColor(res[1], res[0])}`}></div>
              <div className="fx-d-r fx-fsc w-60">
                  <div className="w-100" style={{paddingLeft: '50px'}}>{t(dataHandler_alert(res[0], res[1]).msg)}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="h-100 w-40 fx-d-c legend">
        <div className="w-40 h-20 fx-ccc mar-5 l">{t('GLOBAL.BED_state')}</div>
        <div className="gridLegend_row h-70 fx-d-c">
          {row3.map((res) => (
            <div className="h-80 w-100 fx-d-r fx-ccc" key={String(res[1]) + String(res[0])}>
              <div className={`w-15 h-30 bgC-border ${transColor(res[1], res[0])}`}></div>
              <div className="fx-d-r fx-fsc w-60">
                  <div className="w-100" style={{paddingLeft: '50px'}}>{t(dataHandler_alert(res[0], res[1]).msg)}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const LYING_STATES = new Set([4, 7, 8, 13, 15, 103, 501, 502, 503, 504, 505, 511, 512]);
const HIDE_STATES = new Set([208, 211, 212]);

const toNum = (v) => Number(v);
const shouldHideState = (state) => HIDE_STATES.has(toNum(state));
const shouldBeLying = (state) => LYING_STATES.has(toNum(state));

function transColor(state, level, selectedLevel) {
  const s = Number(state);

  // 先處理「躺姿」：不管什麼 level，都直接顯示躺姿顏色
  if (shouldBeLying(s)) {
    return 'bgC-lying';
  }

  if (level === 2) {
    if (s === 14) {
      return 'bgC-sit';
    } else if (s === 12) {
      return 'bgC-sit';
    } else if (s === 1) {
      return 'bgC-NIB';
    } else if (s === 218) {
      return 'bgC-NIB';
    } else if (s === 217) {
      return 'bgC-longLying';
    } else {
      return 'bgC-light-pink';
    }
  } else if (level === 1) {
    if (s === 218) {
      return 'bgC-NIB';
    } else if (s === 206) {
      return 'bgC-dark-pink';
    } else if (s === 203) {
      return 'bgC-zigzag-pink';
    } else {
      return 'bgC-sit';
    }
  } else {
    if (s === 1) return 'bgC-NIB';
    if (s === 0) return 'bgC-blueBACK';
    if (s === 12 || s === 14) return 'bgC-sit';
    if (s === 203) return 'bgC-blue_2';
    if (s === 206) return 'bgC-dark-pink';
    if (s === 208) return 'bgC-blueBACK';
    if (s === 217) return 'bgC-blue_2';
    if (s === 218) return 'bgC-NIB';
    return 'bgC-blue_2';
  }
}

// ========================================================
// 核心修正：資料合併、跨天裁切與填補演算法
// ========================================================
const parseAsUTC8 = (str) => {
  if (!str) return NaN;
  const s = String(str).trim();

  // 已經帶時區的字串，直接交給 Date
  if (/[zZ]$|[+-]\d{2}:\d{2}$/.test(s)) {
    return new Date(s).getTime();
  }

  // 一般 "YYYY-MM-DD HH:mm:ss" 或 "YYYY-MM-DDTHH:mm:ss"
  return new Date(s.replace(' ', 'T') + '+08:00').getTime();
};

export const mergeMobilityAndAlerts = (mobilityData, store_alerts, baseDate, isLastActiveDay = false) => {

  const safeAlerts = Array.isArray(store_alerts) ? store_alerts : [];
  const ONE_DAY = 86400000;
  const KNOWN_MOBILITY_TYPES = new Set([411, 421, 431]);

  // ✅ 先算好 startMs / endMs，後面才能用
  const startMs = baseDate;
  const endMs = startMs + ONE_DAY;

  const convertedMobilityData = Array.isArray(mobilityData)
    ? mobilityData
        .filter(item => KNOWN_MOBILITY_TYPES.has(item.mobility_type_id))
        .map(item => {
          const mobilityToBedState = { 411: 12, 421: 4, 431: 1 };
          return {
            bed_id: safeAlerts[0]?.bed_id || 0,
            resident_id: safeAlerts[0]?.resident_id || 0,
            bedState: mobilityToBedState[item.mobility_type_id],
            timestamp: item.start_datetime.replace('T', ' '),
            bedStateAlertLevel: 0,
            __src: `mobility_${item.mobility_type_id}`,
          };
        })
    : [];

  const allStoreAlerts = safeAlerts
    .map(alert => ({ ...alert, __src: alert.__src || 'alert' }));

  const mergedData = [
    ...allStoreAlerts,
    ...convertedMobilityData,
  ].sort((a, b) => parseAsUTC8(a.timestamp) - parseAsUTC8(b.timestamp));

  // ✅ 這裡用到 startMs / endMs，現在已經宣告好了
  const lastEventInWindow = [...mergedData]
    .reverse()
    .find(item => {
      const t = parseAsUTC8(item.timestamp);
      return t >= startMs && t < endMs;
    });

  // 修改後
  const nowMs = new Date().getTime();
  const isToday = nowMs >= startMs && nowMs < endMs;
  // ✅ 判斷是否為患者最後一天（非今天且隔天無資料）

  const effectiveEndMs = (() => {
    if ((isLastActiveDay || isToday) &&      // ← 只有這兩種情況才截斷
        lastEventInWindow && shouldHideState(lastEventInWindow.bedState)) {
      const lastHideMs = parseAsUTC8(lastEventInWindow.timestamp);
      const prevBeforeHide = [...mergedData]
        .reverse()
        .find(item =>
          parseAsUTC8(item.timestamp) < lastHideMs &&
          parseAsUTC8(item.timestamp) >= startMs
        );
      return prevBeforeHide
        ? parseAsUTC8(prevBeforeHide.timestamp)
        : lastHideMs;
    }
    if (isLastActiveDay && lastEventInWindow && !shouldHideState(lastEventInWindow.bedState)) {
      return parseAsUTC8(lastEventInWindow.timestamp);
    }
    return endMs;
  })();
  if (isLastActiveDay && !lastEventInWindow) {
    return [];
  }
  const displayData = mergedData.filter(item => !shouldHideState(item.bedState));

  // ✅ 先算 lastBeforeStart，作為「是否為最初有資料的第一天」的依據
  const lastBeforeStart = [...displayData]
    .reverse()
    .find(item => parseAsUTC8(item.timestamp) < startMs);

  const windowData = displayData.filter(item => {
    const t = parseAsUTC8(item.timestamp);
    return t >= startMs && t < effectiveEndMs;
  });

// ── 提前計算 windowRaw，規則 A 需要在 lastBeforeStart 判斷之前就執行 ──
  const windowRaw = mergedData.filter(item => {
    const t = parseAsUTC8(item.timestamp);
    return t >= startMs && t < endMs;
  });

  // ── 規則 A 提前檢查：isToday 或 isLastActiveDay 時，
  //    不管 lastBeforeStart 是否存在，都要優先判斷是否隱藏整天 ──
  if (windowRaw.length >= 2) {
    const _firstIsNonHide = !shouldHideState(windowRaw[0].bedState);
    const _secondIsHide   = shouldHideState(windowRaw[1].bedState);

    if (_firstIsNonHide && _secondIsHide) {
        const _hasThirdNonHide = windowRaw.slice(2).some(item => !shouldHideState(item.bedState));
        if (!_hasThirdNonHide && (isToday || isLastActiveDay) && !lastBeforeStart) {
            return [];
        }
    }
  }

  if (lastBeforeStart) {
    windowData.unshift(lastBeforeStart);
  } else {
    // ── 最初有資料的第一天（前面沒有任何歷史資料）──
    // windowRaw 已在上方計算好，直接使用
    const firstIsNonHide =
      windowRaw.length >= 1 && !shouldHideState(windowRaw[0].bedState);
    const secondIsHide =
      windowRaw.length >= 2 && shouldHideState(windowRaw[1].bedState);

    if (firstIsNonHide && secondIsHide) {
      const hasThirdNonHide = windowRaw
        .slice(2)
        .some(item => !shouldHideState(item.bedState));

      if (hasThirdNonHide) {
        const thirdNonHide = windowRaw
          .slice(2)
          .find(item => !shouldHideState(item.bedState));

        const segStart = Math.max(parseAsUTC8(windowRaw[0].timestamp), startMs);
        const segEnd = parseAsUTC8(thirdNonHide.timestamp);

        if (segEnd <= segStart) return [];

        return [{
          ...windowRaw[0],
          secs: (segEnd - segStart) / 1000,
          left: ((segStart - startMs) / ONE_DAY) * 100,
          index: 1,
        }];
      }
    }
  }

  const lastBeforeEnd = [...displayData]
    .reverse()
    .find(item => parseAsUTC8(item.timestamp) < effectiveEndMs);

  if (lastBeforeEnd && parseAsUTC8(lastBeforeEnd.timestamp) < effectiveEndMs) {
    windowData.push({
      ...lastBeforeEnd,
      timestamp: new Date(effectiveEndMs + 8 * 3600000)
          .toISOString()
          .slice(0, 19)
          .replace('T', ' '),
      __boundary: 'end',
    });
  }

  const processedData = [];

  for (let i = 0; i < windowData.length - 1; i++) {
    const current = windowData[i];
    const next = windowData[i + 1];
    if (!next) continue;

    const currentTime = parseAsUTC8(current.timestamp);
    const nextTime = parseAsUTC8(next.timestamp);

    const segmentStart = Math.max(currentTime, startMs);
    const segmentEnd = Math.min(nextTime, effectiveEndMs);  // ✅ 也用 effectiveEndMs

    if (segmentEnd <= segmentStart) continue;
    if (segmentEnd <= startMs || segmentStart >= effectiveEndMs) continue;

    processedData.push({
      ...current,
      secs: (segmentEnd - segmentStart) / 1000,
      left: ((segmentStart - startMs) / ONE_DAY) * 100,
      index: i + 1,
    });
  }

  return processedData;
};


export const createTimeArray = () => {
  const hours = [];
  for (let hour = 8; hour <= 32; hour++) {
    let displayHour = hour;
    if (hour > 23) {
      displayHour = hour - 24;
    }

    for (let min = 0; min < 60; min += 20) {
      if (hour === 32 && min > 0) break;
      hours.push({
        hour: displayHour,
        minute: min,
      });
    }
  }
  return hours;
};

function getDisplayState(state) {
  const s = Number(state);

  // 躺姿分類
  if ([7, 8, 103, 501, 502, 503, 504, 505, 511, 512].includes(s)) {
    return 4; // 或 15、13，視你想顯示成哪個躺姿文字
  }

  // 跳過類型：不單獨顯示
  if ([208, 211, 212].includes(s)) {
    return null;
  }

  return s;
}

export function dataHandler_alert(alert_level = '', alert_state = '') {
  const level = alert_level.toString();
  const rawState = Number(alert_state);
  const displayState = getDisplayState(rawState);

  if (displayState === null) {
    return {
      level: comm_data[`LEVEL_${level}`],
      img: undefined,
      msg: '',
    };
  }

  const NEW_images = {
    1: comm_imgs[`LEVEL_${level}`]['1_NO_IN_BED'],
    4: comm_imgs[`LEVEL_${level}`]['4_IN_BED'],
    7: comm_imgs[`LEVEL_${level}`]['7_left_lying'],
    8: comm_imgs[`LEVEL_${level}`]['8_right_lying'],
    12: comm_imgs[`LEVEL_${level}`]['12_SIT_UP'],
    13: comm_imgs[`LEVEL_${level}`]['13_ENTER'],
    14: comm_imgs[`LEVEL_${level}`]['14_EXIT'],
    15: comm_imgs[`LEVEL_${level}`]['15_SIDE_LYING'],
    203: comm_imgs[`LEVEL_${level}`]['203_HARNESSBREAK'],
    206: comm_imgs[`LEVEL_${level}`]['206_TRANSCEIVER_OFFLINE'],
    208: comm_imgs[`LEVEL_${level}`]['208_TRANSCEIVER_ONLINE'],
    211: comm_imgs[`LEVEL_${level}`]['211_RESOLVE_ALERT_BY_BED'],
    212: comm_imgs[`LEVEL_${level}`]['212_RESOLVE_ALERT_BY_STATION'],
    217: comm_imgs[`LEVEL_${level}`]['217_LONG_STAY'],
    218: comm_imgs[`LEVEL_${level}`]['218_LEAVING_OVERTIME'],
    501: comm_imgs[`LEVEL_${level}`]['501_AWAKE_DETECTED'],
    502: comm_imgs[`LEVEL_${level}`]['502_AWAKE_RESTLESS'],
    503: comm_imgs[`LEVEL_${level}`]['503_AWAKE_EMERGE'],
    504: comm_imgs[`LEVEL_${level}`]['504_AWAKE_ALREADY'],
    505: comm_imgs[`LEVEL_${level}`]['505_RESTLESS_CHECK'],
    511: comm_imgs[`LEVEL_${level}`]['511_MOBILITY_TOO_HIGH'],
    512: comm_imgs[`LEVEL_${level}`]['512_MOBILITY_TOO_LOW'],
  };

  return {
    level: comm_data[`LEVEL_${level}`],
    img: NEW_images[displayState],
    msg: comm_data[`ALERT_STATE_${displayState}`],
  };
}
const comm_data = {
  ALERT_STATE_1: 'GLOBAL.ALERT_STATE_1',
  ALERT_STATE_4: 'HISTORY_RECORD.MOBILITY_LYING',
  ALERT_STATE_7: 'GLOBAL.ALERT_STATE_7',
  ALERT_STATE_8: 'GLOBAL.ALERT_STATE_8',
  ALERT_STATE_12: 'HISTORY_RECORD.MOBILITY_SITTING',
  ALERT_STATE_13: 'HISTORY_RECORD.MOBILITY_LYING',
  ALERT_STATE_14: 'HISTORY_RECORD.MOBILITY_SITTING',
  ALERT_STATE_15: 'HISTORY_RECORD.MOBILITY_LYING',
  ALERT_STATE_103: 'HISTORY_RECORD.MOBILITY_LYING',
  ALERT_STATE_203: 'GLOBAL.ALERT_STATE_203',
  ALERT_STATE_206: 'GLOBAL.ALERT_STATE_206_2',
  ALERT_STATE_208: 'GLOBAL.ALERT_STATE_208',

  ALERT_STATE_211: 'GLOBAL.ALERT_STATE_211',
  ALERT_STATE_212: 'GLOBAL.ALERT_STATE_212',
  
  ALERT_STATE_217: 'GLOBAL.ALERT_STATE_217',
  ALERT_STATE_218: 'GLOBAL.ALERT_STATE_1',
  ALERT_STATE_501: 'GLOBAL.ALERT_STATE_501',
  ALERT_STATE_502: 'GLOBAL.ALERT_STATE_502',
  ALERT_STATE_503: 'GLOBAL.ALERT_STATE_503',
  ALERT_STATE_504: 'GLOBAL.ALERT_STATE_504', 
  ALERT_STATE_505: 'GLOBAL.ALERT_STATE_505',
  ALERT_STATE_511: 'GLOBAL.ALERT_STATE_511',
  ALERT_STATE_512: 'GLOBAL.ALERT_STATE_512',
};